<template>
  <div class="record">
    <div class="players">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="player" v-for="item in list" :key="item.id">
            <div class="top">
              <div style="display: flex; align-items: center">
                <van-image class="image" :src="imageView(item.avatar)" width="66" height="66" fit="contain"></van-image>
                <div class="info">
                  <div class="name">{{ item.trueName }}</div>
                  <div class="date">{{ formatDate(item.createDate, '{y}-{m}-{d} {h}:{i}') }}</div>
                </div>
              </div>
              <div class="status _1" v-if="item.result === 1">通过</div>
              <div class="status _2" v-else-if="item.isArtificial === 1">人工检录不通过</div>
              <div class="status _3" v-else>扫码检录不通过</div>
            </div>
            <div class="type">检录范围：<span v-if="item.inspectionType === 0">按赛程</span><span v-else>按日期</span></div>
            <div class="detail" v-if="item.inspectionType === 0">
              {{ getDetail(item) }}
            </div>
            <div class="detail" v-else>
              {{ formatDate(item.inspectionBeginDate, '{y}-{m}-{d}')}}
              {{ ['全天', '上午（12点前）', '中午（12点后）', '晚间（18点后）'].find((a, i) => i === item.inspectionTimeInterval) }}
              {{ item.location }}
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage, PullRefresh, List } from 'vant'
import { getUserInspectionResult } from '@/api/match'
import { DateUtil, QNImageUtil } from '@/utils'
Vue.use(VanImage).use(PullRefresh).use(List)
export default {
  data() {
    return {
      unionMatchId: '',
      pageNum: 1,
      list: [],
      loading: false,
      finished: false,
      refreshing: false
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
  },
  methods: {
    getDetail(item) {
      const a = []
      if (item.group) a.push(item.group)
      if (item.name) a.push(item.name)
      if (item.inspectionRound) a.push(`第 ${item.inspectionRound} 轮`)
      if (item.inspectionGameId) a.push(`${item.homeTeamName } vs ${item.awayTeamName}`)
      return a.join(' / ')
    },
    onLoad() {
      this.getUserInspectionResult()
    },
    onRefresh() {
      // 清空列表数据
      this.list = []
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNum = 1
      this.onLoad()
    },
    formatDate(date, type) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, type)
    },
    imageView(img) {
      if (!img) {
        return ''
      }
      return QNImageUtil.imageView(img)
    },
    getUserInspectionResult() {
      const params = {
        unionMatchId: this.unionMatchId,
        pageSize: 10,
        pageNum: this.pageNum
      }
      getUserInspectionResult(params).then(res => {
        if (res) {
          const { data } = res
          const list = data.list || []
          if (this.refreshing) this.refreshing = false
          if (list.length < 10) {
            this.finished = true
          }
          this.pageNum++
          this.loading = false
          this.list = this.list.concat(list)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.record {
  background-color: #F8F8F8;
  min-height: 100vh;
  padding: 0 12px;
  .players {
    padding-top: 12px;
    .player {
      background-color: #FFFFFF;
      border-radius: 8px;
      padding: 8px 12px;
      margin-bottom: 12px;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .info {
          margin-left: 12px;
          .name {
            color: #333333;
            font-size: 16px;
          }
          .date {
            color: #8C8C8C;
            font-size: 12px;
          }
        }
        .status {
          font-size: 16px;
          color: #333333;
        }
        ._1 {
          color: #0ABB58;
        }
        ._2 {
          color: #FF613B;
        }
        ._3 {
          color: #FF3726;
        }
      }
      .type {
        margin-top: 4px;
        font-size: 13px;
        color: #191919;
      }
      .detail {
        font-size: 13px;
        color: #191919;
      }
    }
  }
}
</style>
